const locale = require('./splitSubmission.i18n.json');

/*@ngInject*/
const SplitSubmissionModalController = function ($rootScope, $scope, options, coreMediator, coreConstant) {

    $scope.i18n = locale;

    $scope.viewModel = {
        title: _.get($scope.i18n, 'title'),
        cancelButton: _.get($scope.i18n, 'cancel'),
        okButton: _.get($scope.i18n, 'splitSubmission'),
        submissionProductsList: [],
        selectedSplitProducts: [],
        productShortNames: _.split(options.productShortNames, ','),
        splitButtonTooltip: ''
    };

    $scope.getSplitButtonTooltip = function () {
        if ($scope.viewModel.selectedSplitProducts.length === 0) {
            return _.get($scope.i18n, 'selectAtLeastOneProductTooltip');
        } else if ($scope.viewModel.selectedSplitProducts.length === $scope.viewModel.submissionProductsList.length) {
            return _.get($scope.i18n, 'cannotSelectAllProductsTooltip');
        }
        return null;
    };

    $scope.canEnableConfirmButton = function () {
        return !($scope.viewModel.selectedSplitProducts.length === 0 || $scope.viewModel.selectedSplitProducts.length === $scope.viewModel.submissionProductsList.length);
    };

    $scope.handleClick = function (product) {
        if (product.checked) {
            $scope.viewModel.selectedSplitProducts.push(product.value);
        } else {
            _.pull($scope.viewModel.selectedSplitProducts, product.value);
        }
    };

    $scope.onConfirm = function () {
        $scope.$close({
            productShortNames: $scope.viewModel.selectedSplitProducts
        });
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    function getAuthorizedProducts() {
        var dynamicDataSetParams = {
            name: 'User Authorized Products',
            submissionUri: 'com.firstbest.underwriting.submission.Submission:' + options.submissionId
        };

        coreMediator.getDynamicDataSetItems(dynamicDataSetParams).then(function (response) {
            _.each(response, function (item) {
                if (_.indexOf($scope.viewModel.productShortNames, item.value) !== -1) {
                    $scope.viewModel.submissionProductsList.push(item);
                }
            });
        });
    }

    getAuthorizedProducts();

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('splitSubmissionModalController', SplitSubmissionModalController);
